<template>
  <Transition name="fade" mode="out-in" appear>
    <div
      v-if="visible"
      class="route-loader"
      aria-live="polite"
      aria-busy="true"
    >
      <div class="loader-container">
        <div class="spinner">
          <div class="logo-icon">
            <img src="/img/logo_y.svg" alt="CrowdHR Icon" />
          </div>
          <svg viewBox="0 0 100 100" class="circular">
            <circle
              class="path"
              cx="50"
              cy="50"
              r="40"
              fill="none"
              stroke-width="3"
              stroke-miterlimit="10"
            />
          </svg>
        </div>
      </div>
    </div>
  </Transition>
</template>

<script>
export default {
  name: 'LoadingSpinner',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        document.body.classList.add('loading-active')
      } else {
        document.body.classList.remove('loading-active')
      }
    },
  },
  beforeUnmount() {
    document.body.classList.remove('loading-active')
  },
}
</script>

<style lang="scss" scoped>
.route-loader {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.6);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9998;
  will-change: opacity;
  contain: strict;

  .loader-container {
    display: flex;
    align-items: center;
    justify-content: center;
    transform: translateZ(0);

    .spinner {
      position: relative;
      width: 80px;
      height: 80px;
      contain: strict;

      .logo-icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 30px;
        height: 30px;
        z-index: 2;
        will-change: transform;

        img {
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }

      .circular {
        animation: rotate 1.5s linear infinite;
        transform-origin: center center;
        width: 100%;
        height: 100%;
        margin: auto;
        position: absolute;
        top: 0;
        left: 0;
        will-change: transform;
      }

      .path {
        stroke: #fc6c2a;
        stroke-dasharray: 89, 200;
        stroke-dashoffset: 0;
        stroke-linecap: round;
        animation: dash 1.2s ease-in-out infinite;
        stroke-width: 3;
        will-change: stroke-dashoffset, stroke-dasharray;
      }
    }
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

@keyframes rotate {
  100% {
    transform: rotate(360deg);
  }
}

@keyframes dash {
  0% {
    stroke-dasharray: 1, 200;
    stroke-dashoffset: 0;
  }
  50% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -35px;
  }
  100% {
    stroke-dasharray: 89, 200;
    stroke-dashoffset: -124px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .circular {
    animation-duration: 2.5s !important;
  }
  .path {
    animation-duration: 2s !important;
  }
}
</style>
